// Texte des „Erlebnis“-Teils der Startseite: das Eröffnungsbanner
// (Hero/HeroSection.jsx), der Ablauf in 4 Fotos (HowItWorks.jsx) und die
// spielbare Demo (GameDemo.jsx).
// Übersetzung von fr/experience.js — exakt dieselben Schlüssel.
export default {
  /* ----------------------------------------------------- HeroSection */

  'hero.badge': '🤫 Sie wissen es schon. Die anderen noch nicht.',

  // Der Titel steht auf zwei Zeilen, die zweite mit Farbverlauf.
  'hero.titre.ligne1': 'Verraten Sie ihnen',
  'hero.titre.ligne2': 'DAS GROSSE GEHEIMNIS',

  // Satz rund um die <strong> und die <br /> geschnitten: der Fettdruck räumt
  // das Missverständnis aus („nicht SIE erfahren hier das Geschlecht“).
  'hero.accroche.fort': 'Sie kennen das Geschlecht Ihres Babys. Ihre Liebsten noch nicht.',
  'hero.accroche.texte':
    'Dieses Spiel lässt sie raten: zwei Teams, 11 Fragen „Mama oder Papa?“, und ein letztes Puzzleteil zum Freirubbeln, das es allen gleichzeitig verrät.',
  'hero.accroche.objet': '📦 Eine echte Spielbox aus Karton, zu Ihnen nach Hause geliefert.',

  'hero.cta.offre': '✨ Unser Angebot entdecken',
  'hero.cta.enSavoirPlus': '↓ Mehr erfahren',

  'hero.atout.pieces': '12 Teile, nicht 1000',
  'hero.atout.joueurs': 'Von 2 bis 10 Spielern',
  'hero.atout.duree': '20 Minuten',

  'hero.imageAlt':
    'Joyful Reveal — Gender-Reveal-Spiel von Mirum Games: das Puzzle mit den zwei Bärchen, „baby boy“ oder „baby girl“',
  'hero.scroll': 'Scrollen und entdecken',

  /* ------------------------------------------------------ HowItWorks */

  'how.badge': 'Das Szenario',
  'how.titre': 'Laden Sie sie zum Essen ein. Sagen Sie nichts.',
  'how.description':
    'Für sie ist es ein Essen wie jedes andere. Beim Dessert schlagen Sie ein kleines Gesellschaftsspiel vor … und genau da beginnt alles. Zwanzig Minuten später wissen sie es.',

  'how.etape1.titre': '„Spielen wir eine Runde?“',
  'how.etape1.texte':
    'Die Schachtel kommt auf den Tisch. Jeder wählt sein Lager – Team Mädchen oder Team Junge – und Sie stellen die erste der elf Fragen „Mama oder Papa?“.',
  'how.etape1.alt':
    'Der Inhalt des Spiels Joyful Reveal: die Box, der Fragebogen und die beiden Stoffbeutel',

  'how.etape2.titre': 'Wer antworten will, macht Lärm',
  'how.etape2.texte':
    'Kein Handheben: Kinderspielzeug schnappen – Rasseln, Quietschspielzeug – und so viel Lärm machen wie möglich. Sie entscheiden, welches Team antworten darf.',
  'how.etape2.alt': 'Die beiden Stoffbeutel, die den beiden Teams überreicht werden',

  'how.etape3.titre': 'Die Stimmung steigt und steigt',
  'how.etape3.texte':
    'Das Team, das Sie nicht gewählt haben, macht bei der nächsten Frage doppelt so viel Lärm. Dann das andere. Jede richtige Antwort bringt ein Teil; nach dem elften setzen alle gemeinsam das Puzzle zusammen.',
  'how.etape3.alt': 'Das Joyful-Reveal-Puzzle fertig im goldenen Rahmen, das Rubbelteil noch grau',

  'how.etape4.titre': 'Das zwölfte Teil wird freigerubbelt',
  'how.etape4.texte':
    'Eine letzte Frage, ein einziger Gewinner. Erst Stille, dann der Schrei: der Moment, von dem Ihre Liebsten noch jahrelang erzählen werden.',
  'how.etape4.alt':
    'Eine Hand rubbelt mit einer Münze das letzte Puzzleteil frei: das Wort GIRL erscheint',

  // Schlusssatz rund um den Link geschnitten: „<Link> — Fortsetzung“.
  'how.lienRegles': 'Die vollständigen Spielregeln lesen',
  'how.lienReglesSuite': '— Fragen inklusive, druckfertig.',

  // « Le secret des parents » — carte affichée sous le scénario (accueil,
  // fiche produit) et repliée sur la page des règles, que le QR code de la
  // boîte ouvre aussi pour les invités.
  'secret.label': '🤫 Nur für die Eltern',
  'secret.titre': 'Das Geheimnis der Eltern',
  'secret.texte':
    'Nur Sie kennen die Fragen im Voraus, und Sie wählen, welches Team antwortet. So können Sie dem Glück ganz diskret ein wenig nachhelfen.',
  'secret.parrain':
    'Sie möchten jemanden bitten, Pate oder Patin zu werden? Geben Sie seinem oder ihrem Team das Wort, wenn Sie wissen, dass er oder sie die Antwort kennt. Stellen Sie im Finale eine Frage, deren Antwort eine Zahl ist, die Sie ihm oder ihr ein paar Tage vorher anvertraut haben. Seine oder ihre Hand wird das letzte Teil freirubbeln.',
  'secret.chute': 'Und die nächste Frage stellen Sie.',
  'secret.afficher': '👀 Geheimnis anzeigen (nur für die Eltern)',

  /* -------------------------------------------------------- GameDemo */

  'demo.badge': 'Jetzt ausprobieren — eine Partie im Schnelldurchlauf',
  'demo.titre': 'Spielen Sie mit, wie am großen Tag',
  'demo.intro':
    'Zwei Teams, elf Fragen, ein Puzzle, das Gestalt annimmt. Das zwölfte Teil wird freigerubbelt — und genau das verrät alles. Hier ist die Partie, in einer Minute.',

  // Ansagen für Screenreader (aria-live): jeder Schritt der Demo.
  'demo.etape.pari': 'Schritt 1 von 4 — bilden Sie Ihr Team',
  'demo.etape.questions': 'Schritt 2 von 4 — gewinnen Sie die Teile',
  'demo.etape.cascade': 'Schritt 2 von 4 — das Puzzle füllt sich',
  'demo.etape.subsidiaire': 'Schritt 3 von 4 — die Schätzfrage',
  'demo.etape.grattage': 'Schritt 4 von 4 — die große Enthüllung',
  'demo.etape.final': 'Partie beendet',
  'demo.aria.resultat': 'Ergebnis der Demo: Es ist {mot}.',

  // Das ausgeloste Geschlecht, so wie es in die Sätze passt: „Es ist {mot}!“
  'demo.resultat.fille': 'ein MÄDCHEN',
  'demo.resultat.garcon': 'ein JUNGE',

  'demo.puzzle.aria': 'Puzzle der Demo: {n} Teil(e) von 12 gelegt',
  'demo.puzzle.pieceAGratter': 'Das Rubbelteil',
  'demo.puzzle.compteur': '🧩 {n}/12 Teile — das echte Bild des Puzzles (14 × 21 cm)',

  'demo.pari.etiquette': 'Schritt 1 — wie in den Spielregeln: Wir bilden die Teams',
  'demo.pari.titre': 'Und Sie, was sagt Ihr Bauchgefühl?',
  'demo.pari.fille': '💗 Ich tippe auf ein MÄDCHEN',
  'demo.pari.garcon': '💙 Ich tippe auf einen JUNGEN',
  'demo.pari.note':
    'Am großen Tag schließt sich jeder dem Team seiner Intuition an. Hier wird das Ergebnis ausgelost — bei Ihnen zu Hause ist es Ihr echtes Geheimnis.',

  'demo.questions.etiquette': 'Frage {numero} von 11 — aus dem echten Fragebogen',
  // Echte Fragen aus dem Fragebogen in der Box (ursprüngliche Nummern).
  // WORTGLEICH mit de/regles.js (regles.questions.q5 / q7 / q11) — beide Stellen
  // zeigen dieselbe Frage, jede Änderung muss dort nachgezogen werden.
  'demo.question.5': 'Wer singt Schlaflieder katastrophal?',
  'demo.question.7': 'Wer weint bei Kinderfilmen?',
  'demo.question.11':
    'Wer könnte das Baby versehentlich wecken, weil er auf ein lautes Spielzeug tritt?',
  'demo.questions.maman': '🤱 Mama',
  'demo.questions.papa': '🧔 Papa',
  'demo.questions.gagne': '🧩 Teil gewonnen! Es wandert ins Puzzle…',
  'demo.questions.note':
    'Im echten Spiel entscheiden die werdenden Eltern — und man muss schneller antworten als das gegnerische Team.',

  'demo.cascade.titre': '…und die anderen acht gewinnt man genauso.',
  'demo.cascade.texte':
    'Frage für Frage füllt sich das Puzzle — für die Demo schenken wir sie Ihnen. Gleich bleibt nur noch ein einziges Teil übrig.',

  'demo.subsidiaire.etiquette':
    'Ein Teil fehlt — die Schätzfrage entscheidet, wer es freirubbeln darf',
  // Die DEMO-Frage — absichtlich eine ANDERE als die echte Schätzfrage des
  // Spiels, damit die Startseite die Überraschung des großen Tages nie
  // verdirbt. Deshalb darf die Demo hier die Antwort verraten.
  'demo.subsidiaire.question':
    'Wie viele Stunden pro Tag schläft ein Neugeborenes im Durchschnitt?',
  'demo.subsidiaire.labelEstimation': 'Ihre Schätzung der Stundenzahl',
  'demo.subsidiaire.placeholder': 'Ihre Schätzung…',
  'demo.subsidiaire.valider': 'Ich wage einen Tipp!',
  // Rückmeldesatz, rund um die <strong> (die eingegebene Schätzung) und das
  // <sup> geschnitten. Im Deutschen macht die Ordnungszahl „12.“ den
  // Hochstellungs-Schlüssel überflüssig — er bleibt bewusst leer.
  'demo.subsidiaire.retourAvant': 'Ihre Schätzung:',
  'demo.subsidiaire.retourApres':
    '. Die Antwort: rund 16 bis 17 Stunden pro Tag! Am großen Tag kommt eine andere Frage — sie steht samt Antwort in der Spielanleitung 😉.',
  'demo.subsidiaire.retourPiece': 'Wer am nächsten dran liegt, gewinnt das 12.',
  'demo.subsidiaire.retourExposant': '',
  'demo.subsidiaire.retourFin': 'Puzzleteil. Heute gehört diese Ehre Ihnen.',
  'demo.subsidiaire.cta': '🪙 Das 12. Teil freirubbeln',

  'demo.grattage.etiquette': 'Das 12. Teil liegt in Ihren Händen',
  // Die beiden Zeilen, die auf die Silberschicht gemalt werden (Canvas).
  'demo.grattage.grattez': '✨ RUBBELN ✨',
  'demo.grattage.doigtOuSouris': 'Finger oder Maus',
  'demo.grattage.aria': 'Das Teil ist freigerubbelt: Es ist {mot}.',
  'demo.grattage.revele': 'Es ist {mot}! Das Teil wandert ins Puzzle…',
  'demo.grattage.revelerMaintenant': 'Sofort enthüllen',
  'demo.grattage.revelerSansGratter': 'Ohne Rubbeln enthüllen',

  'demo.final.titre': 'Es ist {mot}!',
  'demo.final.pariGagne': 'Und Ihr Team hatte richtig getippt. Respekt.',
  'demo.final.pariPerdu': 'Das andere Team hatte recht — das passiert den Besten.',
  // Satz rund um die <strong> geschnitten: davor / das fette Wort / danach.
  'demo.final.texteAvant': '…in dieser Demo jedenfalls. Am großen Tag ist es',
  'demo.final.texteFort': 'Ihr',
  'demo.final.texteApres':
    'Geheimnis, das Ihre Liebsten entdecken — und das fertige Puzzle (14 × 21 cm, genau ein Rahmenformat) bleibt als Erinnerung.',
  'demo.final.ctaBoutique': '🛒 Das will ich bei mir zu Hause erleben',
  'demo.final.rejouer': '↺ Nochmal spielen',
};
